import axios from "../../api";
import store from "../../store";
import { clearLoginData } from "../hooks/useUser";
import { refreshToken } from "../../api/login";
import { applyCSSVariables, defaultColors } from "../../utils/themeUtils";
import { clearSessionTimers } from "../session/sessionTimer";
import { jwtDecode } from "jwt-decode";

export const getCurrentUser = () =>
  JSON.parse(localStorage.getItem("userData") || "{}");
export const getAuthToken = () => {
  return localStorage.getItem("token") || "";
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken") || "";
};

export const getToken = () => {
  const token = getAuthToken();
  return token || "";
};
export const refreshAccessToken = async (): Promise<string> => {
  try {
    const response = await refreshToken();
    const access = response.data?.data?.access_token;
    const refresh = response.data?.data?.refresh_token;

    if (access && refresh) {
      localStorage.setItem("token", access);
      localStorage.setItem("refreshToken", refresh);

      const decoded: any = jwtDecode(access);
      if (decoded?.exp) {
        localStorage.setItem("expiryTime", (decoded.exp * 1000).toString());
      }

      return access;
    }

    throw new Error("Failed to refresh access token");
  } catch (error) {
    console.error("Token refresh failed:", error);
    throw error;
  }
};

export const handleLogin = (details: any = {}) => {
  const newLoginData = {
    tenantDetails: details?.tenantDetails || null,
    userDetails: details?.userDetails || null,
    userLimitExceeded: details?.userLimitExceeded || false,
    gracePeriod: details?.gracePeriod || false,
    isEmailConfigured: details?.isEmailConfigured || false,
    isTwilioConfigured: details?.isTwilioConfigured || false,
  };

  localStorage.setItem("loginData", JSON.stringify(newLoginData));
  localStorage.setItem("userData", JSON.stringify(details?.userDetails));
  const { primaryColor, accentColor } = details?.tenantDetails ?? {};
  applyCSSVariables(primaryColor, accentColor);
  store.dispatch({
    type: "SESSION:SET_IS_LOGGED_IN",
    payload: {
      value: true,
      tenantDetails: details?.tenantDetails,
      userDetails: details?.userDetails,
    },
  });
};

export const logout = () => {
  store.dispatch({
    type: "SESSION:SET_IS_LOGGED_IN",
    payload: {
      value: false,
    },
  });

  // Reset set loading to display login.
  store.dispatch({
    type: `APPEARANCE:SET_LOADING`,
    payload: {
      value: false,
    },
  });

  store.dispatch({ type: "SUPPORT:RESET_STATE", payload: { value: {} } });

  localStorage.removeItem("userData");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.setItem("activeMenu", "Dashboard");
  localStorage.removeItem("activeSubMenu");
  localStorage.removeItem("activeFooter");
  localStorage.removeItem("activeFooterSubMenu");
  localStorage.removeItem("firstTimeLogin");
  localStorage.removeItem("expiryTime");
  applyCSSVariables(defaultColors?.primaryColor, defaultColors?.accentColor);
  clearLoginData();
  clearSessionTimers();
};
